import type { FaireProductEntity } from "../../entity_types/product";

export const p_vtnj9zpt9q: FaireProductEntity = {
  token: "p_vtnj9zpt9q",
  type: "product",
  name: "mr duck mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/331572b1708dc629a12ff82b7a9530d9e5d26efaa58053399c7e74e7b3f15b54.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2bdb283ffea32055c27236f64dda420ed64c0c05b8096139c09c42c9a18844ce.jpeg",
    "https://cdn.faire.com/fastly/9dec1c7fde064c0de84fdc549961fcefbf36c937aaad904d9704db911d0d61d0.jpeg",
    "https://cdn.faire.com/fastly/80029d8e40de659340fc375ccfe1ecda44c5d04be7807ba76827f112cadc3e87.jpeg",
    "https://cdn.faire.com/fastly/75d13546c9bda16b517c194bf3ede844f65df0cd7ae92befa144163e059e62e6.jpeg",
    "https://cdn.faire.com/fastly/0a1189d5dfdce9f63ac6cfb8fc13714b1de2603a93fbd92fbc01272091dee21e.jpeg",
    "https://cdn.faire.com/fastly/523afa9a9235aadd76e9c10e9b49a7c71b7a2183a99a362402b03109ba43af88.jpeg",
  ],
  priceDollars: 2,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty presentation. Pairs adorably with a Twirl book.\n\n\nDetails:\n\n- single card + envelope + sticker for sealing\n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex from the book Twirl\n',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:52.536Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
